export default class ITBlog {
    count;
    likeUser;
}